<template>
  <div class="wrap">
    <div class="row justify-content-center">
      <div class="col-12 content">
        <Trophy />
      </div>
    </div>
  </div>
</template>

<script>
import Trophy from "Components/Sections/Trophy.vue";
export default {
  name: "Gewinnspiel",
  components: {
    Trophy,
  },
};
</script>
<style scoped>
#mainNav {
  display: none !important;
}

.wrap {
  background-color: black !important;
  font-family: "Roboto Condensed", sans-serif;
  width: 100%;
  padding-top: 10vh;
}
</style>


